// target blank
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
} 

// target menu
document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll(".wbsimplemenuxs a");

  links.forEach(link => {
    if (link.textContent.trim().includes("Händleranfrage")) {
      link.classList.add("highlight-link");
    }
  });
});
